module.exports = __webpack_public_path__ + "static/simufact03-5db7e93e9745e8c7a20b7b48f7f09e71.png";